<template>
  <div data-testid="featured-destinations-section">
    <div :class="['ml-4 md:ml-[5%] md:mr-[5%] e1:mx-auto e1:w-[90%] e1:max-w-[1136px]', { 'mr-4': featuredCount === 1 }]">
      <h3 class="mb-5 flex scroll-mt-20 font-Spectral text-xl tracking-wide text-gold4 md:mb-4 md:text-[26px] md:leading-[40px]">
        <template v-if="type === 'itinerary'">
          <a class="flex items-center gap-x-1 hover:opacity-80" rel="noopener noreferrer" target="_blank" :href="JOURNEYS_LP_URL">
            {{ sectionTitle }}
            <img alt="" aria-hidden="true" class="h-7 w-7" src="~@/assets/icon/arrow/right-gold500.svg" />
          </a>
        </template>
        <template v-else>
          {{ sectionTitle }}
        </template>
        <span class="mx-2 flex flex-grow items-center">
          <span class="h-[0.5px] flex-grow bg-gold4"></span>
        </span>
      </h3>
      <MoleculesHorizontalScrollWrapper scroll-button-box-style="h-[400px]" :is-single-child-filled="true">
        <div :class="{ 'flex gap-2': true, 'w-full': featuredCount <= MAX_ITEMS_FOR_EQUAL_WIDTH }">
          <template v-for="(featured, index) in featuredList" :key="index + featured.id">
            <FeaturedCard
              :class="MIN_ITEMS_FOR_EQUAL_WIDTH <= featuredCount && featuredCount <= MAX_ITEMS_FOR_EQUAL_WIDTH ? 'flex-1' : ''"
              :featured="featured"
              :for-single-content="featuredCount === 1"
              :is-display-view-more="featuredCount <= MAX_ITEMS_FOR_EQUAL_WIDTH"
              :on-featured-click="handleFeaturedClick"
              :type="type"
            />
          </template>
          <!-- View All Card for itinerary type -->
          <a v-if="type === 'itinerary'" class="flex snap-center flex-col gap-2 font-Spectral md:gap-4" rel="noopener noreferrer" target="_blank" :href="JOURNEYS_LP_URL">
            <div class="relative flex h-[350px] w-full min-w-[280px] flex-col items-center justify-center bg-white md:h-[400px] md:min-w-[320px]">
              <img alt="" aria-hidden="true" class="h-[80px] w-[120px]" src="~@/assets/logo/wabunka/symbol.svg" />
              <div class="mt-2 flex items-center gap-x-1 text-light-fg-accent">
                <span>View All</span>
                <img alt="" aria-hidden="true" class="h-3 w-3" src="~@/assets/icon/right/gold.svg" />
              </div>
            </div>
          </a>
        </div>
      </MoleculesHorizontalScrollWrapper>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { JOURNEYS_LP_URL } from '@/wabunka-src/constants/journeysLp';
import { type FeaturedType, type MinimumFeaturedListViewModel } from '@/wabunka-src/features/Featured';
import { FeaturedCard } from '@/wabunka-src/features/Featured';
// 定数定義
const MIN_ITEMS_FOR_EQUAL_WIDTH = 2;
const MAX_ITEMS_FOR_EQUAL_WIDTH = 3;

interface Props {
  featuredList: MinimumFeaturedListViewModel;
  type: FeaturedType;
  onFeaturedClick?: (type: string, id: string) => void;
}

const props = defineProps<Props>();

const featuredCount = computed(() => props.featuredList.length);

const sectionTitle = computed(() => {
  if (props.type === 'destination') {
    return 'Featured Destinations';
  } else if (props.type === 'itinerary') {
    return 'A Journey Designed for You';
  } else if (props.type === 'theme') {
    return 'Explore by Theme';
  }
  return '';
});

const handleFeaturedClick = (type: string, id: string) => {
  if (props.onFeaturedClick) {
    props.onFeaturedClick(type, id);
  }
};
</script>

<!-- tailwindの範囲外のSCSS -->
<style lang="scss" scoped>
.vertical-text {
  writing-mode: vertical-rl;
  text-orientation: mixed;
  -webkit-writing-mode: vertical-rl;
  -ms-writing-mode: tb-rl;
  -webkit-text-orientation: mixed;
  text-combine-upright: none;
  -webkit-text-combine-upright: none;
}
</style>
